import Vue from "vue";
import VueHtml2Canvas from "vue-html2canvas";
import vuetify from "./plugins/vuetify";
import "./assets/scss/main.scss";
import ModicoStampMaker from "./ModicoStampMaker.vue";

let dev = false;

Vue.config.productionTip = true;
Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = true;

if (dev) {
  Vue.config.productionTip = false;
  Vue.config.devtools = true;
  Vue.config.debug = true;
  Vue.config.silent = true;
  window.$ = window.jQuery = require("jquery");
} else {
  window.$ = window.jQuery;
}

Vue.use(VueHtml2Canvas);
// window.$ = window.jQuery = require("jquery");
// window.$ = window.jQuery;

const mountEl = document.querySelector("#app");

new Vue({
  vuetify,
  render: createElement => {
    const context = {
      props: { ...mountEl.dataset }
    };
    return createElement(ModicoStampMaker, context);
  }
}).$mount("#app");
